module.exports = __webpack_public_path__ + "static/media/Pista_CabeloPreto.e7134f4d.png";